import getBoundaryCoordinates from 'ha/modules/Algolia/utils/getBoundaryCoordinates';
import normalizeCoordinate from 'ha/modules/Algolia/utils/normalizeCoordinate';
import { ReqParams, SearchParams } from './types';

export default (reqParams: ReqParams, searchParams: SearchParams) =>
  reqParams.topLat &&
  reqParams.rightLng &&
  reqParams.bottomLat &&
  reqParams.leftLng
    ? [
        [
          normalizeCoordinate(reqParams.topLat),
          normalizeCoordinate(reqParams.rightLng),
          normalizeCoordinate(reqParams.bottomLat),
          normalizeCoordinate(reqParams.leftLng),
        ],
      ]
    : [
        getBoundaryCoordinates(
          searchParams.latitude,
          searchParams.longitude,
          searchParams.radius / 1000,
        ),
      ];
